import type {
  ChatChannel,
  PromptCreateInput,
  PromptTemplate,
  PromptUpdateInput,
} from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const promptsApi = {
  list(query: { chatbot_id?: string; channel?: ChatChannel } = {}) {
    return request<{ items: PromptTemplate[]; default_content: string }>(
      "/admin/prompts",
      { query },
    );
  },
  create(input: PromptCreateInput) {
    return request<{ prompt: PromptTemplate }>("/admin/prompts", {
      method: "POST",
      body: input,
    });
  },
  update(id: string, input: PromptUpdateInput) {
    return request<{ prompt: PromptTemplate }>(`/admin/prompts/${id}`, {
      method: "PATCH",
      body: input,
    });
  },
  remove(id: string) {
    return request<{ ok: true }>(`/admin/prompts/${id}`, { method: "DELETE" });
  },
};
